import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import queryString from 'query-string';
import { insightsCanvasRendererHostBridge, isCanvasRendererHost } from 'src/app/canvas-renderer/canvas-renderer-host';
import { AppModule } from './app/app.module';
import { isDevEnvironment } from './client-config';
import { environment } from './environments/environment';

declare function InsightsIdpLogoutCallback(redirectUri: string);

if (window.location.pathname == '/connect/endsession/callback') {
  InsightsIdpLogoutCallback('/');
}
else {
  if (isCanvasRendererHost) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ = insightsCanvasRendererHostBridge;
  }

  (async () => {
    let debugMode = !environment.production || !!queryString.parse(window.location.search)['debugAngular']?.length;
   
    if (!debugMode) {
      enableProdMode();
    }

    if (isDevEnvironment) {
      await platformBrowserDynamic().bootstrapModule(AppModule);
    }
    else {
      try {
        await platformBrowser().bootstrapModule(AppModule);
      }
      catch (err) {
        if (!isDevEnvironment()) {
          console.error(err);
        }
      }
    }
  })();
}
